import { render, staticRenderFns } from "./Build.vue?vue&type=template&id=90190708&scoped=true&"
import script from "./Build.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Build.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Build.vue?vue&type=style&index=0&id=90190708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90190708",
  null
  
)

export default component.exports